import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  card: {
    overflow: 'hidden',
    marginTop: 32,
    marginBottom: 32,
  },
  adminCard: {
    overflow: 'hidden',
  },
  topContainer: {
    padding: 32,
  },
  searchForm: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 16,
  },
};

export default styles;
